import { render, staticRenderFns } from "./ModalUpdateOrCreateNameDocument.vue?vue&type=template&id=07b6a7b0"
import script from "./ModalUpdateOrCreateNameDocument.vue?vue&type=script&lang=js"
export * from "./ModalUpdateOrCreateNameDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports